import { Col, SelectField } from '@/components';
import type { SharedSearchFormType } from '@/features/search/_models/shared-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import {
  ProjectCategoryLabelModifier,
  projectCategoryEnum,
} from '@/utils/enum';
import { type FC, memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const options = projectCategoryEnum.options.map((value) => ({
  value,
  label: ProjectCategoryLabelModifier[value],
}));

export const CategoriesColField: FC = memo(() => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext<SharedSearchFormType>();

  const sheetType = useWatch({
    control,
    name: 'sheetType',
  });

  if (sheetType === 'KS') {
    return null;
  }

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <SelectField
        name="categories"
        label={t('project-category')}
        control={control}
        options={options}
        errors={errors}
        mode="multiple"
      />
    </Col>
  );
});
